import { render, staticRenderFns } from "./orders_detail_table_panel.vue?vue&type=template&id=68172c08&scoped=true&lang=pug"
import script from "./orders_detail_table_panel.vue?vue&type=script&lang=js"
export * from "./orders_detail_table_panel.vue?vue&type=script&lang=js"
import style0 from "./orders_detail_table_panel.vue?vue&type=style&index=0&id=68172c08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68172c08",
  null
  
)

export default component.exports